import { render, staticRenderFns } from "./boxsearch.vue?vue&type=template&id=17777d26&scoped=true&"
import script from "./boxsearch.vue?vue&type=script&lang=js&"
export * from "./boxsearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17777d26",
  null
  
)

export default component.exports